import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/catalogos/modificacion-de-jornada';

/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getJornadasModificacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJornadaModificacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJornadaModificacion = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJornadaModificacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 *
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const getJornadaModificacionTotales = async (id, values) => {
  try {
    const response = await API.get(`/nominas/descuentos-carga-externa-archivo-totales-vista-optimized/${id}/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteJornadaModificacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarJornadaModificacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const CancelarJornadaModificacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
